<div class="modal-content" piqetAngularDraggable>
  <ng-container *ngrxLet="customFacade.fillingIngredientList$ as fillingProcessList">
    <div class="modal-header">
      <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
        <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
          {{ modalLabel }}
        </div>
      </h2>

      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body body-modal" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
      <form id="frmProjectCreate" [formGroup]="customFillingForm">
        <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group required">
              <piqet-angular-common-input
                formControlName="fillingName"
                [control]="customFillingForm.get('fillingName')"
                label="Filling process name"
                placeholder="Filling process name"
                [maxLength]="50"
                [submitted]="submitted"
                [errorMessages]="{
                  required: 'Filling process name is required',
                  whitespace: 'Filling process name is required'
                }"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 form-group required">
            <label class="sub-header-drpdown"> Unit</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              class="productItems"
              #select
              [items]="unitofProductItems"
              [searchable]="false"
              formControlName="productName"
              bindLabel="name"
              [searchFn]="commonInputSearch"
              bindValue="id"
              placeholder="Unit"
            >
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted && customFillingForm.get('productName')?.errors"
              class="input-error"
            >
              <div
                *ngIf="customFillingForm.controls['productName'].errors?.['required']"
                class="input-error"
              >
                Please select unit.
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6" *ngIf="isHideDropDown">
            <div class="form-group required">
              <label class="sub-header-drpdown pb-2">Organization</label>
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #material
                [items]="organizationlist"
                [searchable]="false"
                bindLabel="name"
                formControlName="organizationName"
                [searchFn]="commonInputSearch"
                [readonly]="isDisabledDropDown"
                placeholder="Organization"
                [(ngModel)]="setOrganizationValue"
                (change)="selectValue($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      (input)="material.filter($any($event.target).value)"
                      class="accordion-search form-control search-input"
                      id="inputValidation"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (customFillingForm.controls['organizationName']?.touched &&
                    customFillingForm.controls['organizationName']?.invalid) ||
                  customFillingForm.controls['organizationName'].value?.name ===
                    '-- Select Organization -- ' ||
                  (submitted && !customFillingForm.controls['organizationName'].value?.name)
                "
                class="input-error"
              >
                Organization is required.
              </div>
            </div>
          </div>
        </div>
      </form>
      <label class="sub-header-drpdown"
        >Add the process inputs to fill 1 kg or 1 litre of product</label
      >
      <div
        id="divmanufactureofmaterialList"
        class="grid-div cutomBtn-margin"
        *ngrxLet="customFacade.customFillingError$ as error"
      >
        <input
          data-val="true"
          data-val-number="The field CustomMaterialId must be a number."
          data-val-required="The CustomMaterialId field is required."
          type="hidden"
          value="0"
        />
        <piqet-angular-portlet
          [columnDefs]="processColumnDef"
          [frameworkComponents]="frameworkComponents"
          [gridData]="fillingProcessList"
          [hidePagination]="true"
          [hideSearch]="true"
          [headerBtn]="headerBtn"
          [headerBtnName]="headerBtnName"
          [showErrorInAccordian]="true"
          [disableButton]="disableSubmit || isRowEditable"
          [isCheckOrgaizationReport]="true"
          [error]="error"
          (editDataEvent)="checkValidation(fillingProcessList)"
          [createAccess]="checkEntireAccess"
          (inlineDataEditEvent)="inlineDataEditEvent($event)"
          [inlineEdit]="true"
          [isInlineGrid]="true"
          [class]="'overflowCheck'"
        >
        </piqet-angular-portlet>
      </div>
    </div>
    <div class="modal-footer">
      <ng-container *ngrxLet="customFacade.fillingIngredientList$ as fillingProcessList">
        <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
        <button
          type="button"
          class="modelBtn purpleBtnHoverEffect"
          *ngIf="checkEntireAccess"
          [disabled]="disableSubmit || isRowEditable"
          (click)="onSave(fillingProcessList)"
        >
          Save
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>
